import { supabase } from '@/integrations/supabase/client';
import type { BrandContactsPort } from '../ports/brandContacts.port';

export class ContactsAdapter implements BrandContactsPort {
  async linkBrandToContact(contactId: string, brandId: string): Promise<void> {
    const { data: contact, error: contactFetchError } = await supabase
      .from('contacts')
      .select('linked_brand_ids')
      .eq('id', contactId)
      .single();

    if (contactFetchError) {
      console.error('Error fetching contact for brand link:', contactFetchError);
      throw contactFetchError;
    }

    const currentBrandIds = Array.isArray(contact?.linked_brand_ids)
      ? (contact.linked_brand_ids as string[])
      : [];

    if (!currentBrandIds.includes(brandId)) {
      const updatedBrandIds = [...currentBrandIds, brandId];

      const { error: updateError } = await supabase
        .from('contacts')
        .update({ linked_brand_ids: updatedBrandIds })
        .eq('id', contactId);

      if (updateError) {
        console.error('Error updating contact linked_brand_ids:', updateError);
        throw updateError;
      }
    }
  }
}

export const contactsAdapter = new ContactsAdapter();
